import { render, staticRenderFns } from "./FormPWR2.vue?vue&type=template&id=1d868da2&scoped=true"
import script from "./FormPWR2.vue?vue&type=script&lang=js"
export * from "./FormPWR2.vue?vue&type=script&lang=js"
import style0 from "./FormPWR2.vue?vue&type=style&index=0&id=1d868da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d868da2",
  null
  
)

export default component.exports